/**
 * Single Product Text BG Animation
 * @dependencies splitting.js
 */
import Splitting from "splitting"

const textsBg = document.getElementsByClassName('js-header-textbg')
if (textsBg.length > 0) {

  // Splitting
  for (let index = 0; index < textsBg.length; index++) {
    const textBg = textsBg[index];
    Splitting({ target: textBg })
  }

}
